import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { Observable, map, catchError, of, mergeMap, shareReplay } from 'rxjs';
import * as Sentry from '@sentry/angular';
import { Icon, IconResponse } from '@models/strapi';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  public strapiUrl: string = 'https://admin.mototechna.cz/';
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  private http = inject(HttpClient);

  private iconsLoaded = false;
  private loadIconsCache$?: Observable<boolean>;

  public loadAllStrapiIcons(): Observable<boolean> {
    if (this.iconsLoaded) {
      return of(true);
    }

    if (this.loadIconsCache$) {
      return this.loadIconsCache$;
    }

    this.loadIconsCache$ = this.getAllStrapiIcons().pipe(
      map((icons) => {
        icons.forEach((icon) => {
          if (icon && icon.name) {
            const iconName = icon.name;
            const svgUrl = `/icons/${icon.name}.svg`;
            this.matIconRegistry.addSvgIcon(iconName, this.domSanitizer.bypassSecurityTrustResourceUrl(svgUrl));
          }
        });
        this.iconsLoaded = true;
        return true;
      }),
      catchError((error) => {
        Sentry.captureMessage('Failed to load icons from Strapi: ' + error.message, {
          level: 'fatal',
        });
        this.loadIconsCache$ = undefined;
        return of(false);
      }),
      shareReplay(1),
    );

    return this.loadIconsCache$;
  }

  public getAllStrapiIcons(): Observable<Icon[]> {
    return this.http.get<Icon[]>(environment.iconsApi).pipe(
      catchError((error) => {
        Sentry.captureMessage('Failed to fetch icons from cached API: ' + error.message, {
          level: 'error',
        });
        return of([]);
      }),
    );
  }
}
